import React, { PropsWithChildren } from 'react';

import styles from './settings-section.module.scss';

interface SettingsSectionProps {
  title: string;
}

export const SettingsSection: React.FC<PropsWithChildren<SettingsSectionProps>> = ({
  title,
  children,
}) => (
  <div className={styles['section-items']}>
    <h3>{title}</h3>

    {children}
  </div>
);
